module.exports = __webpack_public_path__ + "static/media/iitk_logo.2e0bb0b4.png";